export default __webpack_public_path__ + "static/media/hidraulic20.416c77e7.jpeg";